import { Record } from 'immutable'

const EnquiryItemRecord = Record({
	id: -1,
	category_id: '',
	category_name: '',
	product_id: '',
	product_name: '',
	brand: '',
	brands: [],
	tc_required: false,
	target_price: null,
	message: '',
	is_unknown_product: false,
	input_type: '',
	required_length: null,
	required_pieces: null,
	required_weight: null,
	grade: null,
	price_per_kg: null,
	hsn_code: null,
})

class SpoEnquiryItem extends EnquiryItemRecord {
	constructor(data = {}) {
		super({
			...data,
			id: data?.id ?? Math.floor(Math.random() * 1000),
		})
	}
}

export default SpoEnquiryItem
